import { render, staticRenderFns } from "./RemoteProviders.vue?vue&type=template&id=f4a96a92&scoped=true&"
import script from "./RemoteProviders.vue?vue&type=script&lang=ts&"
export * from "./RemoteProviders.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteProviders.vue?vue&type=style&index=0&id=f4a96a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a96a92",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VList,VListItem,VListItemAction,VListItemAvatar,VListItemContent,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4a96a92')) {
      api.createRecord('f4a96a92', component.options)
    } else {
      api.reload('f4a96a92', component.options)
    }
    module.hot.accept("./RemoteProviders.vue?vue&type=template&id=f4a96a92&scoped=true&", function () {
      api.rerender('f4a96a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RemoteProviders.vue"
export default component.exports